import React, { useState, useEffect, useRef } from "react";
import {
    TextField,
    Button,
    MenuItem,
    Grid,
    Typography,
    Box,
    Autocomplete,
} from "@mui/material";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import { ref, onValue } from "firebase/database";
import { db } from "../../firebaseConfig";
import Logo from "../../assets/logo1.png";
import "../styles/emprestimochaves.css";

const EmprestimoChave = () => {
    const [corretor, setCorretor] = useState("");
    const [corretores, setCorretores] = useState([]);
    const [cliente, setCliente] = useState("");
    const [cpf, setCpf] = useState("");
    const [nascimento, setNascimento] = useState("");
    const [dataRetirada, setDataRetirada] = useState("");
    const [horaRetirada, setHoraRetirada] = useState("");
    const [dataDevolucao, setDataDevolucao] = useState("");
    const [horaDevolucao, setHoraDevolucao] = useState("");
    const [imoveis, setImoveis] = useState([]);
    const [selectedImoveis, setSelectedImoveis] = useState([]);

    const pdfRef = useRef();

    // Busca corretores
    useEffect(() => {
        const corretoresRef = ref(db, "corretores");
        onValue(corretoresRef, (snap) => {
            if (snap.exists()) {
                const data = Object.entries(snap.val()).map(([id, v]) => ({
                    id,
                    nome: v.nome,
                }));
                setCorretores(data);
            }
        });
    }, []);

    // Busca imóveis
    useEffect(() => {
        const imoveisRef = ref(db, "imoveis");
        onValue(imoveisRef, (snapshot) => {
            if (snapshot.exists()) {
                const data = Object.entries(snapshot.val()).map(([id, val]) => {
                    const info = val.imovelInfo || {};
                    return {
                        id,
                        codigo: info.codigo || "Sem código",
                        cidade: info.cidade || "",
                        bairro: info.bairro || "",
                        endereco: `${info.bairro ? info.bairro + ", " : ""}${info.cidade || ""}`,
                    };
                });
                setImoveis(data);
            }
        });
    }, []);

    const handleImprimir = async () => {
        if (!cliente || !cpf || !dataRetirada || !horaRetirada) {
            alert("Preencha os campos obrigatórios: Cliente, CPF, Data e Hora de Retirada.");
            return;
        }

        const pdfElement = pdfRef.current;
        pdfElement.style.display = "block";

        const canvas = await html2canvas(pdfElement, {
            scale: 2,
            useCORS: true,
            logging: false,
        });

        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF("p", "pt", "a4");
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

        pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
        pdf.save(`Emprestimo_Chaves_${cliente}.pdf`);

        pdfElement.style.display = "none";
    };

    return (
        <div className="emprestimoChave">
            <Typography variant="h5" gutterBottom mb={5} ml={34}>
                Empréstimo de Chaves
            </Typography>

            <Grid container spacing={2} ml={32}>
                <Grid item xs={12} sm={6}>
                    <TextField
                        select
                        label="Corretor Responsável"
                        fullWidth
                        value={corretor}
                        onChange={(e) => setCorretor(e.target.value)}
                    >
                        {corretores.map((c) => (
                            <MenuItem key={c.id} value={c.nome}>
                                {c.nome}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField
                        required
                        label="Nome do Cliente"
                        fullWidth
                        value={cliente}
                        onChange={(e) => setCliente(e.target.value)}
                    />
                </Grid>

                <Grid item xs={12} sm={4}>
                    <TextField
                        required
                        label="CPF"
                        fullWidth
                        value={cpf}
                        onChange={(e) => setCpf(e.target.value)}
                    />
                </Grid>

                <Grid item xs={12} sm={4}>
                    <TextField
                        type="date"
                        label="Data de Nascimento"
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        value={nascimento}
                        onChange={(e) => setNascimento(e.target.value)}
                    />
                </Grid>

                <Grid item xs={12} sm={4}>
                    <Autocomplete
                        multiple
                        options={imoveis}
                        getOptionLabel={(option) => `${option.codigo} - ${option.endereco}`}
                        value={selectedImoveis}
                        onChange={(e, val) => setSelectedImoveis(val)}
                        renderInput={(params) => (
                            <TextField {...params} label="Selecionar Imóvel(is)" fullWidth />
                        )}
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField
                        required
                        type="date"
                        label="Data de Retirada"
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        value={dataRetirada}
                        onChange={(e) => setDataRetirada(e.target.value)}
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField
                        required
                        type="time"
                        label="Horário de Retirada"
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        value={horaRetirada}
                        onChange={(e) => setHoraRetirada(e.target.value)}
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField
                        type="date"
                        label="Data Prevista Devolução"
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        value={dataDevolucao}
                        onChange={(e) => setDataDevolucao(e.target.value)}
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField
                        type="time"
                        label="Horário Previsto Devolução"
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        value={horaDevolucao}
                        onChange={(e) => setHoraDevolucao(e.target.value)}
                    />
                </Grid>
            </Grid>

            <Box mt={3} ml={34}>
                <Button variant="contained" sx={{
                    backgroundColor: "var(--verde)",
                    color: "#fff",
                    "&:hover": {
                        backgroundColor: "var(--bege)", 
                    },
                }}
                    onClick={handleImprimir}
                >
                    Imprimir
                </Button>
            </Box>

            {/* TEMPLATE PDF */}
            <div
                ref={pdfRef}
                style={{
                    display: "none",
                    width: "595px",
                    padding: "40px 50px",
                    backgroundColor: "white",
                    color: "#000",
                    fontFamily: "Arial, sans-serif",
                    fontSize: "11pt",
                    lineHeight: "1.4",
                }}
            >
                <Box textAlign="center" mb={1}>
                    <img src={Logo} alt="Logo" style={{ width: "130px", marginBottom: "5px" }} />
                    <Typography
                        variant="subtitle2"
                        style={{
                            fontSize: "10pt",
                            color: "#333",
                            fontWeight: 500,
                        }}
                    >
                        Senna Viannini - CRECI PJ: 9568
                        <br />
                        São João Del Rei - MG
                        <br />
                        (32) 99900-3833 | www.sennaviannini.com.br
                    </Typography>
                </Box>

                <hr style={{ margin: "10px 0 20px 0" }} />

                <Typography align="center" fontWeight="bold" variant="h6" style={{ fontSize: "12pt" }}>
                    Empréstimo de Chaves
                </Typography>

                {selectedImoveis.map((imv, idx) => (
                    <Typography key={idx} paragraph style={{ fontSize: "10pt" }}>
                        <b>Imóvel Cód. {imv.codigo}</b>
                        <br />
                        Endereço: {imv.endereco}
                    </Typography>
                ))}

                <Typography paragraph style={{ fontSize: "10pt", textAlign: "justify" }}>
                    Recebi da <b>Imobiliaria Senna Viannini - CRECI PJ: 9568</b>, por empréstimo e
                    independente de qualquer compromisso, especialmente por locação, as chaves de
                    acesso do imóvel acima mencionado que me são entregues em confiança e com a
                    finalidade de vistoriar dito imóvel, não caracterizando o referido empréstimo,
                    vínculo locatício.
                </Typography>

                <Typography paragraph style={{ fontSize: "10pt", textAlign: "justify" }}>
                    Assumo, outrossim, o compromisso de devolvê-las ainda hoje, no prazo de 2 (duas)
                    horas, sob pena de pagar as despesas para a confecção de novas chaves, caso não
                    devolva no prazo acima.
                </Typography>

                <Typography paragraph align="right" style={{ fontSize: "10pt", marginTop: "10px" }}>
                    São João Del Rei, {new Date(dataRetirada).toLocaleDateString("pt-BR")}
                </Typography>

                <Typography style={{ fontSize: "10pt" }}>
                    <b>Nome:</b> {cliente} <br />
                    <b>CPF:</b> {cpf} <br />
                    <b>Horário de Saída:</b> {horaRetirada} <br />
                    <b>Devolução prevista:</b> {dataDevolucao} {horaDevolucao}
                </Typography>

                <Box mt={6}>
                    <Typography align="center" style={{ fontSize: "10pt" }}>
                        _______________________________________________
                    </Typography>
                    <Typography align="center" style={{ fontSize: "9pt" }}>
                        Assinatura
                    </Typography>

                    <Box mt={4}>
                        <Typography align="center" style={{ fontSize: "10pt" }}>
                            _______________________________________________
                        </Typography>
                        <Typography align="center" style={{ fontSize: "9pt" }}>
                            Corretor Responsável ({corretor})
                        </Typography>
                    </Box>
                </Box>
            </div>
        </div>
    );
};

export default EmprestimoChave;
